import React from "react";
import {H1, H2, P} from "./style/StyledH";
import {IMAGE_TYPE, Topic} from "./services/constants";
import {Box, ContentDiv, HorizontalDiv} from "./style/StyledDiv";
import {DetailImage, FilmStripImage} from "./style/StyledImage";

type ContentProps = {

    topic: Topic ;

};

export const Content: React.FC<ContentProps> = ({topic}) =>
{
    return (
        <ContentDiv>
            <Box visible={topic.type === IMAGE_TYPE.ABOUT}>
                <h1>Arezoo Moradi</h1>
                <h2>Story teller - Video artist</h2>
                <P><a href="mailto:a84.moradi@gmail.com">a84.moradi@gmail.com</a></P>
                <P><a href="tel:+32489643068">+32489643068</a></P>
            </Box>
            <Box visible={topic.type=== IMAGE_TYPE.BOOK1}>
                <h2>De Poorten</h2>
                <P>
                    "Landloos als de wind kon een hard, triestig fotoboek in zwart-wit zijn over een plaats waar je echt niet wil wonen. Voor Jeroen Janssen en Arezoo Moradi is het glas meer dan halfvol. De kleuren spatten van de pagina’s. De teksten bruisen. Samen bewijzen ze dat de mooiste verhalen echt wel achter de hoek liggen. Dit is human intrest op zijn best".
                </P>
                <h2>Knack Focus</h2>
                <P>
                    Janssen & Moradi show the beauty of fragile people
                </P>
                <h2>De Volkskrant</h2>
                <P>
                    "In woord en beeld schept Landloos als de wind een poëtisch en sfeervol portret van een Gentse buitenwijk. Geen tafereel is te triviaal."
                </P>
                <HorizontalDiv>
                    <DetailImage blur={"0"} src={"./detail/IMG-20251220-WA0006.jpg"}/>
                    <DetailImage blur={"0"} src={"./detail/IMG-20251222-WA0014.jpg"}/>

                </HorizontalDiv>

            </Box>
            <Box visible={topic.type=== IMAGE_TYPE.DETOX}>
                <P>
                    Tijdens deze expositie in het kader van Gent culturele hoofdstad hebben we gewerkt rond een detox machine, een project waarbij waterzuiverheid centraal staat in ons leven.

                </P>

                <HorizontalDiv>
                    <div>
                        <DetailImage blur={"0"} src={"./detail/kidney.jpg"}/>
                    </div>
                    <div>
                        <DetailImage blur={"0"} src={"./detail/IMG-20251222-WA0002.jpg"}/>
                    </div>
                    <div>
                        <DetailImage blur={"0"} src={"./detail/IMG-20251222-WA0006.jpg"}/>
                    </div>
                </HorizontalDiv>


            </Box>
            <Box visible={topic.type=== IMAGE_TYPE.WALK}>
                <P>
                    Bij "De Poorten", een project van Tina de Gendt, was ik co-begeleider om de mensen door de stad te gidsen in een unieke historische wandeling
                </P>
                <HorizontalDiv>
                    <div>
                        <DetailImage blur={"0"} src={"./detail/IMG-20251222-WA0010.jpg"}/>
                    </div>
                </HorizontalDiv>


            </Box>
            <Box visible={topic.type=== IMAGE_TYPE.POORTEN}>
                <HorizontalDiv>
                    <P>
                        Dit audio kunstwerk gaat over onzichtbare steden, een wereld die tot stand komt door de talloze geluiden rondom ons heen
                    </P>
                </HorizontalDiv>


            </Box>
            <Box visible={topic.type=== IMAGE_TYPE.KERSTBOOM}>
                <HorizontalDiv>
                    <div>
                        <DetailImage blur={"0"} src={"./detail/giphy.webp"}/>
                    </div>
                    <P>
                        51.052139757606355, 3.72541255553734
                    </P>
                </HorizontalDiv>


            </Box>
        </ContentDiv>

    );
};